export const SET_VALUE = 'SET_VALUE';
export const SET_ERROR = 'SET_ERROR';
export const RESET = 'RESET';

export const formReducer = (state, action) => {
    switch (action.type) {
        case SET_VALUE:
            return {
                ...state,
                values: {
                    ...state.values,
                    [action.key]: action.value,
                },
            };
        case SET_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    [action.key]: action.error,
                },
            };
        case RESET:
            return action.payload;
        default: {
            return state;
        }
    }
};
